import './topshelf/style';
import FormStructure from './topshelf/form_structure';

export default FormStructure;